<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <v-app id="inspire" class="app">
        <app-toolbar class="app--toolbar"></app-toolbar>
        <app-drawer class="app--drawer"></app-drawer>
        <v-content>
          <!-- Page Header -->
          <!-- <page-header v-if="$route.meta.breadcrumb"></page-header> -->
          <div class="page-wrapper">
            <router-view></router-view>
          </div>
          <!-- App Footer -->
          <!-- <v-footer height="auto" class="white pa-3 app--footer transparent">
            <v-spacer></v-spacer>
            <span class="caption">Vietmap Motrak Web App v1.6</span>
            <v-spacer></v-spacer>
          </v-footer>-->
        </v-content>
        <!-- Go to top -->
        <!-- <app-fab></app-fab> -->
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </template>
    <v-snackbar :timeout="5000" bottom right :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.text }}
      <v-btn flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-dialog v-model="loadingDialog" persistent hide-overlay width="300">
      <v-card color="primary" dark>
        <v-card-text>Đang tải dữ liệu
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="logo-kths">
      <img src="static/images/logo-kths.png" height="80" width="68" style="">
    </div>
  </div>
</template>

<script>
import AppDrawer from '@/components/AppDrawer';
import AppToolbar from '@/components/AppToolbar';
import AppFab from '@/components/AppFab';
import PageHeader from '@/components/PageHeader';
import menu from '@/api/menu';
import AppEvents from './event';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import * as Auth from '@/utils/auth';

export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader
  },
  data: () => ({
    expanded: true,
    rightDrawer: false,
    snackbar: {
      show: false,
      text: '',
      color: ''
    },
    loadingDialog: false
  }),
  computed: {
    ...mapGetters(['selectedVehicle', 'historyFromDate'])
  },
  created () {
    this.getCodeZalo();
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
  },

  methods: {
    ...mapActions(['turnOnSecurity', 'turnOffSecurity', 'getTripReporting', 'turnOffEngine', 'restoreEngine', 'updateLastWaypoint']),
    ...mapMutations(['SET_VIEW_HISTORY_STATE']),
    openThemeSettings () {
      this.$vuetify.goTo(0);
      this.rightDrawer = !this.rightDrawer;
    },
    showMessage (text, type = 'success') {
      this.snackbar = {
        show: true,
        text: text,
        color: type === 'error' ? 'red' : 'green'
      };
    },
    lock (v) {
      this.turnOnSecurity(this.selectedVehicle.id)
        .then(_ => {
          this.showMessage('Gửi lệnh đến thiết bị thành công');
        })
        .catch(_ => {
          this.showMessage('Gửi lệnh đến thiết bị thất bại', 'error');
        });
    },
    unLock (v) {
      this.turnOffSecurity(this.selectedVehicle.id)
        .then(_ => {
          this.showMessage('Gửi lệnh đến thiết bị thành công');
        })
        .catch(_ => {
          this.showMessage('Gửi lệnh đến thiết bị thất bại', 'error');
        });
    },
    turnOff (v) {
      this.turnOffEngine(this.selectedVehicle.id)
        .then(_ => {
          this.showMessage('Gửi lệnh đến thiết bị thành công');
        })
        .catch(_ => {
          this.showMessage('Gửi lệnh đến thiết bị thất bại', 'error');
        });
    },
    restore (v) {
      this.restoreEngine(this.selectedVehicle.id)
        .then(_ => {
          this.showMessage('Gửi lệnh đến thiết bị thành công');
        })
        .catch(_ => {
          this.showMessage('Gửi lệnh đến thiết bị thất bại', 'error');
        });
    },

    viewHistory () {
      this.SET_VIEW_HISTORY_STATE(true);
      this.showLoading(true);
      this.getTripReporting()
        .then(_ => {
          this.showLoading(false);
        })
        .catch(_ => {
          this.showLoading(false);
          this.showMessage(
            `${
              this.selectedVehicle.plate
            } không có dữ liệu trong thời gian được chọn`,
            'error'
          );
        });
    },
    viewWarning () {
      this.showMessage('Chức năng đang phát triển', 'error');
    },
    editVehicle () {
      this.showMessage('Chức năng đang phát triển', 'error');
    },
    showLoading (isShow) {
      this.loadingDialog = isShow;
    },

    // Lấy code zalo để user đăng nhập bằng zalo
    getCodeZalo () {
      let location = window.location;
      if (!location.search.includes('?uid=')) return;
      let search = location.search;
      
      let indexCode = search.indexOf('code');
      let indexEnd = search.indexOf('&state');
      let code  = search
        .slice(indexCode, indexEnd)
        .replace('code=', '');
      Auth.setCodeZaloUser(code);
    },

    updateWaypoint () {
      let data = {
        vehicleId: this.selectedVehicle.id
      };
      this.updateLastWaypoint(data).then(_ => {
        window.getApp.showMessage('Cập nhật vị trí thành công');
      }).catch(_ => {
        window.getApp.showMessage('Cập nhật vị trí thất bại', 'error');
      });
      console.log('updateWaypoint -> updateWaypoint');
    }
  }
};
</script>

<style lang="stylus">
.page-wrapper {
  min-height: calc(100vh - 64px - 50px - 81px);
}

.transparent {
  background: none;
}

.left {
  float: left;
}

.right {
  float: right;
}

.clear {
  clear: both;
}

.logo-kths {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  background: #fff;
  padding: 24px;
  border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue